import '@less/index.less'
import '@sass/index.sass'
import { buildApp } from './app.js'
import { generateApiUrl } from './../config/urls.js'

const { app, router, store } = buildApp(window.ENV_VAR)

const rawInitialState = window.INITIAL_DATA

// Cypress tests can inject window.__transformInitialData__ to mutate the SSR state before hydration,
// e.g. to clear store data so API calls can be intercepted and mocked.
const storeInitialState = typeof window.__transformInitialData__ === 'function'
  ? window.__transformInitialData__(rawInitialState)
  : rawInitialState

if (storeInitialState) {
  store.replaceState(storeInitialState)
}

if (!store.state.Global.baseApiUrl) {
  const baseApiUrl = generateApiUrl(window.location.hostname)
  store.dispatch('Global/updateBaseApiUrl', baseApiUrl)
}

router.isReady().then(() => {
  app.mount('#app', true)
})
